import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import numeral from 'numeral'
import { Icon, Div, P } from 'konsys-ui'
import { Tooltip } from 'antd'
import { ChevronsUpDown } from 'lucide-react'
import { status, statusText } from '../constants'
import {
  InputWithPlaceHolder, ActionSelectors, HeaderLabel, CellText, StatusSelector,
} from '../../../components/bill-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          วันที่วางบิล <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'createdDate',
    sortable: true,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 120,
  }, {
    Header: () => <HeaderLabel>ใบปะหน้า <ChevronsUpDown color={color.coolGrey} /></HeaderLabel>,
    accessor: 'refId',
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
    sortable: true,
    filterable: true,
    width: 180,
  }, {
    Header: () => <HeaderLabel>ผู้จ้าง</HeaderLabel>,
    accessor: 'Job.Customer.companyName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 300,
  }, {
    Header: () => <HeaderLabel>ยอดเงิน</HeaderLabel>,
    accessor: 'grandTotal',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{numeral(props.value).format('0,0.00')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 120,
  }, {
    Header: () => <HeaderLabel>วันที่ครบกำหนดชำระเงิน <ChevronsUpDown color={color.coolGrey} /></HeaderLabel>,
    accessor: 'dueDate',
    sortable: true,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 170,
  }, {
    Header: () => <HeaderLabel>ยอดสุทธิ</HeaderLabel>,
    accessor: 'amountReceived',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 120,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => (
      <P bold color={_.includes([status.OVERDUE, status.CANCELLED], props.value)
        ? color.error
        : props.value === status.WAITING
          ? color.warning
          : props.value === status.PAID && color.success}>
      {
        props.value === status.WAITING
          ? statusText.WAITING
          : props.value === status.OVERDUE
            ? statusText.OVERDUE
            : props.value === status.PAID
              ? statusText.PAID
              : props.value === status.CANCELLED
                ? statusText.CANCELLED
                : statusText.ALL
      }
      </P>
    ),
    filterMethod: (filter, row) => filter.value === row.status || filter.value === 'ALL',
    Filter: ({ onChange }) => <StatusSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
    width: 170,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelectors props={props} refetch={() => props.tdProps.rest.refetch()} />,
    width: 150,
  }],
}
